import { Fragment } from "react";
import { INLINE_CODE } from "./styles";

/**
 * Plain text with `backtick` spans as inline code: the endpoint definitions
 * and the error table are written that way. Nothing else is interpreted (no
 * HTML, no links), so registry text can't inject markup.
 */
export function RichText({ text }: { text: string }) {
  const parts = text.split(/(`[^`\n]+`)/);
  return (
    <>
      {parts.map((part, i) =>
        part.length > 2 && part.startsWith("`") && part.endsWith("`") ? (
          <code key={i} className={INLINE_CODE}>
            {part.slice(1, -1)}
          </code>
        ) : (
          part
        ),
      )}
    </>
  );
}

/** Inline code from a literal (for prose written in this feature). */
export function C({ children }: { children: React.ReactNode }) {
  return <code className={INLINE_CODE}>{children}</code>;
}

/**
 * An identifier (`quota_exceeded`, `games_players`) that may wrap after an
 * underscore on a narrow screen and nowhere else, so a table column can be
 * narrow without splitting words at random letters.
 */
export function Ident({ text }: { text: string }) {
  const parts = text.split("_");
  return (
    <>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {part}
          {i < parts.length - 1 && (
            <>
              _<wbr />
            </>
          )}
        </Fragment>
      ))}
    </>
  );
}
